import React from "react";
import PropTypes from "prop-types";
import { Heading as ChakraHeading } from "@chakra-ui/core";

function Heading({ children }) {
  return (
    <ChakraHeading
      as="h2"
      color="orchidBlue"
      fontWeight="300"
      fontSize={["36px", "36px", "60px"]}
      pb="26px"
    >
      {children}
    </ChakraHeading>
  );
}

Heading.propTypes = {
  children: PropTypes.node,
};

export default Heading;
